import React, { Component } from "react";
import { connect } from "react-redux";

import axios from "../../../../services/axios-service";
import * as actions from "../../../../store/actions/index";
import { Link } from "react-router-dom";
import MediaQuery from "react-responsive";
import MainJobTitle from "../../../../components/Client/MainJobTitle/MainJobTitle";
import Button from "../../../../components/UI/Button/Button";
import { Table } from "react-bootstrap";
// import CsvIcon from "../../../../assets/images/csv-file-format.svg";
import viewIcon from "../../../../assets/images/interview-view-action.svg";
import Icon from "../../../../components/UI/Icon/Icon";
import "./ClientInterviewsListContainer.css";
import withErrorHandler from "../../../../hoc/withErrorHandler/withErrorHandler";
import ConsoleLog from "../../../../hoc/ConsoleLog/ConsoleLog";
import Loader from "../../../../components/UI/Loader/Loader";

class ClientInterviewsListContainer extends Component {
  state = {
    loading: true,
    candidateData: [],
    interviewScheduledData: null,
    buttonDisable: false
  };

  /**
   * @desc redux call to get  candidate list  according to jobId on loading the page.
   * @param null
   * @return null
   */
  componentDidMount() {
    this.fetchInterviewDataList(this.props.jobTitleId);
    if (this.props.pool && this.props.pool.length > 0) {
      const data = this.props.pool.filter(
        item => item.candidate_status === "PROGRESS"
      );
      this.setState({ candidateData: data });
    }

    if (
      localStorage.getItem("jobTitleId") &&
      localStorage.getItem("jobTitleId") !== "" &&
      localStorage.getItem("jobTitleId") !== "null"
    ) {
      this.handleJobSelected(localStorage.getItem("jobTitleId"));
      this.props.onGetTalentPool(this.props.jobTitleId, this.props.user);
    }
    if (this.props.pool && this.props.pool.length > 0) {
      const data = this.props.pool.filter(
        item => item.candidate_status === "PROGRESS"
      );
      this.setState({ candidateData: data });
    }
  }
  /**
   * @desc fetches the interview and candidate list on update
   * @param prevProps, prevState
   * @return null
   */
  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.jobs !== prevProps.jobs &&
      localStorage.getItem("jobTitleId") &&
      localStorage.getItem("jobTitleId") !== "" &&
      localStorage.getItem("jobTitleId") !== "null"
    ) {
      this.handleJobSelected(localStorage.getItem("jobTitleId"));
      // this.props.onGetTalentPool(this.props.jobTitleId,this.props.user);
    }
    if (this.props.jobTitleId !== prevProps.jobTitleId) {
      this.fetchInterviewDataList(this.props.jobTitleId);
    }
    if (
      this.state.interviewScheduledData !== null &&
      prevState.interviewScheduledData != this.state.interviewScheduledData
    ) {
      let total = null;
      this.state.interviewScheduledData.interviews.map(el => {
        total += parseInt(el.candidates_requested.split("/")[0]);
      });
      if (total == this.state.interviewScheduledData.progressed) {
        this.setState({ buttonDisable: true });
      } else {
        this.setState({ buttonDisable: false });
      }
    }
  }
  /**
   * @desc fetches the interview
   * @param jobId
   * @return null
   */
  fetchInterviewDataList = jobId => {
    if (this.props.pool) {
      axios
        .get("/galaxy/interview?jobId=" + jobId)
        .then(response => {
          ConsoleLog("response notification", response.data);
          const interviewScheduledData = response.data;
          this.setState({ interviewScheduledData, loading: false });
          ConsoleLog(
            "scheduler",
            this.state.interviewScheduledData.interviews,
            this.state.interviewScheduledData.interviews.length,
            this.state.interviewScheduledData.progressed
          );
        })
        .catch(error => {
          ConsoleLog(error);
          throw error;
        });
    }
  };
  handleJobSelected = jobId => {
    const jobList = [...this.props.jobs];
    if (jobList.length > 0 && jobList.find(job => job.job_id == jobId)) {
      const job = jobList.find(job => job.job_id == jobId);
      const jobTitle = job.job_name;
      const jobBHID = job.job_bh_id;
      const companyType = job.company_type;
      this.props.onSetJobTitles(jobId, jobTitle, jobBHID, companyType);
      // this.props.onGetTalentPool(jobId,this.props.user);
    }
  };
  viewInterviewList = clientId => {
    ConsoleLog("check link");
    this.props.history.push({
      pathname: "/interviews/interview-view",
      state: { clientId: clientId }
    });
  };
  render() {
    return (
      <div className="interviews-main-container">
        {this.state.loading ? (
          <Loader />
        ) : (
          <React.Fragment>
            <div className="interviews-title-main-section">
              <MainJobTitle
                titleClass={"interview-title "}
                className={"main-job-head"}
                user_id={this.props.clientDetails.user_id}
                currentPage="interviews"
                handleJobSelected={this.handleJobSelected.bind(this)}
              />
              {this.state.interviewScheduledData &&
              this.state.interviewScheduledData.progressed !== 0 &&
              this.state.interviewScheduledData.interviews &&
              this.state.interviewScheduledData.interviews.length > 0 ? (
                <div className="request-new-inerview">
                  <Link
                    to={{
                      pathname: this.state.buttonDisable ? "" : "/interview",
                      state: {}
                    }}
                  >
                    <Button
                      disabled={this.state.buttonDisable}
                      className="request-new-inerview-section"
                    >
                      Request New Interview
                    </Button>
                  </Link>
                </div>
              ) : (
                ""
              )}
            </div>
            {this.state.interviewScheduledData &&
            this.state.interviewScheduledData.progressed != 0 &&
            this.state.interviewScheduledData.interviews &&
            this.state.interviewScheduledData.interviews.length === 0 ? (
              <div className="no-interview-scheduled-section">
                <hr />
                <p className="no-interview-scheduled-text">
                  There are no interviews currently scheduled.
                </p>
                <Link
                  to={{
                    pathname: "/interview",
                    state: {}
                  }}
                >
                  <Button className="request-new-inerview-section">
                    Request New Interview
                  </Button>
                </Link>
              </div>
            ) : (
              ""
            )}
            {/* Mobile view starts */}
            <MediaQuery query="(max-device-width: 769px)">
              {this.state.interviewScheduledData &&
              this.state.interviewScheduledData.progressed == 0 ? (
                <div className="no-progressed-candidates">
                  <hr className="review-candidate-hrline"></hr>
                  <div className="review-candidate-text">
                    <p className="review-candidate-text-header">
                      No progressed candidates to schedule an interview.
                    </p>
                    <p className="review-candidate-text-content">
                      By reviewing and giving feedback on your candidate list
                      you will be able to start the interview process.
                    </p>
                  </div>
                  <div>
                    <Link
                      to={{
                        pathname: "/",
                        state: {}
                      }}
                    >
                      <Button className="review-new-inerview-section">
                        Review Candidate List
                      </Button>
                    </Link>
                  </div>
                </div>
              ) : (
                this.state.interviewScheduledData &&
                this.state.interviewScheduledData.progressed !== 0 &&
                this.state.interviewScheduledData.interviews.length > 0 &&
                this.state.interviewScheduledData.interviews.map(
                  (interview, index) => {
                    const interviewStatus =
                      interview.client_interview_status === "Completed"
                        ? "Scheduled"
                        : interview.client_interview_status === "Pending"
                        ? "Pending Recruiter Review"
                        : "Rejected";
                    const interviewStatusIcon =
                      interview.client_interview_status === "Completed"
                        ? "accepted"
                        : interview.client_interview_status === "Pending"
                        ? "client-pending-icon"
                        : "rejected";
                    const interviewStatusClass =
                      interview.client_interview_status === "Completed"
                        ? "Scheduled"
                        : interview.client_interview_status === "Pending"
                        ? "Pending"
                        : "Rejected";
                    return (
                      <div
                        className={
                          "interviewlist-mobile-card " + interviewStatusClass
                        }
                        onClick={() =>
                          this.viewInterviewList(interview.client_interview_id)
                        }
                      >
                        <div className="interview-date">
                          Date:{" "}
                          <span className="date-value">
                            {new Date(interview.created_date)
                              .toISOString()
                              .replace(/T.*/, "")
                              .split("-")
                              .reverse()
                              .join("/")}
                          </span>
                        </div>
                        <div className="interview-round">
                          {interview.client_interview_type}
                        </div>
                        <div className="interview-location">
                          {interview.client_interview_location}
                        </div>
                        <hr className="interview-hr-line"></hr>
                        <div className="interview-candidate-count">
                          No. of Candidates requseted{" "}
                          <span>{interview.candidates_requested}</span>
                        </div>
                        <div className="interview-accepted">
                          Accepted <span>{interview.accepted}</span>{" "}
                        </div>
                        <div className="interview-status">
                          Status{" "}
                          <Icon
                            className={
                              "interview-status-icon " + interviewStatusClass
                            }
                            icon={interviewStatusIcon}
                          />{" "}
                          <span>{interviewStatus}</span>
                        </div>
                      </div>
                    );
                  }
                )
              )}
            </MediaQuery>
            {/* Mobile view Ends */}
            {/* Desktop view starts */}
            <MediaQuery query="(min-device-width: 768px)">
              {this.state.interviewScheduledData &&
              this.state.interviewScheduledData.progressed == 0 ? (
                <div className="no-progressed-candidates">
                  <hr className="review-candidate-hrline"></hr>
                  <div className="review-candidate-text">
                    <p className="review-candidate-text-header">
                      No progressed candidates to schedule an interview.
                    </p>
                    <p className="review-candidate-text-content">
                      By reviewing and giving feedback on your candidate list,
                      you will be able to start the interview process.
                    </p>
                  </div>
                  <div>
                    <Link
                      to={{
                        pathname: "/",
                        state: {}
                      }}
                    >
                      <Button className="review-new-inerview-section">
                        Review Candidate List
                      </Button>
                    </Link>
                  </div>
                </div>
              ) : this.state.interviewScheduledData &&
                this.state.interviewScheduledData.progressed !== 0 &&
                this.state.interviewScheduledData.interviews.length > 0 ? (
                <div className="interview-list-main-table">
                  <Table className="interview-List-Table" striped condensed>
                    <thead className="interview-list-table-thead">
                      <tr>
                        <th className="interview-date">Date</th>
                        <th className="interview-round">Interview Round</th>
                        <th className="interview-location">Location</th>
                        <th className="interview-candidate-count">
                          No. of candidates
                          <br /> requested
                        </th>
                        <th className="interview-accepted">Accepted</th>
                        <th className="interview-status">Status</th>
                        <th className="interview-action">Action</th>
                      </tr>
                    </thead>
                    <tbody className="interview-list-table-body">
                      {this.state.interviewScheduledData.interviews.map(
                        (interview, index) => {
                          const interviewStatus =
                            interview.client_interview_status === "Completed"
                              ? "Scheduled"
                              : interview.client_interview_status === "Pending"
                              ? "Pending Recruiter Review"
                              : "Rejected";
                          const interviewStatusIcon =
                            interview.client_interview_status === "Completed"
                              ? "accepted-icon"
                              : interview.client_interview_status === "Pending"
                              ? "client-pending-icon"
                              : "rejected";
                          const interviewStatusClass =
                            interview.client_interview_status === "Completed"
                              ? "Scheduled"
                              : interview.client_interview_status === "Pending"
                              ? "Pending"
                              : "Rejected";
                          return (
                            <tr key={index}>
                              <td className="interview-date">
                                {new Date(interview.created_date)
                                  .toISOString()
                                  .replace(/T.*/, "")
                                  .split("-")
                                  .reverse()
                                  .join("/")}
                              </td>
                              <td className="interview-round">
                                {interview.client_interview_type}
                              </td>
                              <td className="interview-location">
                                {interview.client_interview_location}
                              </td>
                              <td className="interview-candidate-count">
                                {interview.candidates_requested}
                              </td>
                              <td className="interview-accepted">
                                {interview.accepted}
                              </td>
                              <td className="interview-status">
                                <Icon
                                  className={
                                    "interview-status-icon " +
                                    interviewStatusClass
                                  }
                                  icon={interviewStatusIcon}
                                />
                                {interviewStatus}{" "}
                              </td>
                              <td
                                className={
                                  "interview-action " + interviewStatusClass
                                }
                              >
                                {/* <div className="interview-actions-more-container" > */}
                                <img
                                  src={viewIcon}
                                  onClick={() =>
                                    this.viewInterviewList(
                                      interview.client_interview_id
                                    )
                                  }
                                />

                                {/* </div> */}
                              </td>
                            </tr>
                          );
                        }
                      )}
                    </tbody>
                  </Table>
                </div>
              ) : (
                ""
              )}
            </MediaQuery>
            {/* Desktop view Ends */}
          </React.Fragment>
        )}
      </div>
    );
  }
}

/**
 * @desc connecting to redux store
 * @param state
 * @return redux state
 */
const mapStateToProps = state => {
  return {
    pool: state.talentPool.pool,
    activeCandidateId: state.talentPool.activeCandidateId,
    jobTitleId: state.talentPool.jobTitleId,
    profileInfo: state.candidateProfile.profileInfo,
    jobs: state.talentPool.jobList,
    user: state.cognito.user,
    clientDetails: state.clientProfile.clientDetails,
    companyType: state.talentPool.companyType,
    jobTitle: state.talentPool.jobTitle,
    jobTitleBHID: state.talentPool.jobTitleBHID
  };
};

/**
 * @desc connecting to redux actions
 * @param dispatch
 * @return redux actions
 */

const mapDispatchToProps = dispatch => {
  return {
    onGetTalentPool: (jobTitleId, user) =>
      dispatch(actions.getTalentPool(jobTitleId, user)),
    // onViewCandidate: (canidateId,jobTitleId) => dispatch(actions.viewCandidate(canidateId,jobTitleId)),
    // onGetProfileDetails: (canidateId, jobTitleId,isClient,user) => dispatch(actions.getProfileDetails(canidateId, jobTitleId,isClient,user)),
    // onSelectCandidate: (canidateId, jobTitleId,isClient) => dispatch(actions.getProfileDetails(canidateId, jobTitleId,isClient=true)),
    onSetJobTitles: (jobTitleId, jobTitle, jobBHID, companyType) =>
      dispatch(actions.setJobTitle(jobTitleId, jobTitle, jobBHID, companyType))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(ClientInterviewsListContainer, axios));



// WEBPACK FOOTER //
// ./src/container/Client/ClientInterviews/ClientInterviewsListContainer/ClientInterviewsListContainer.js